import React from 'react';
  
// Creating the context object and passing the default values.
const globalContext = React.createContext(null);
  
export default globalContext;